import theme from '@/style';
import {NativeTouchableOpacity} from '@/components/basic/touchable-opacity';
import React, {ReactNode} from 'react';
import {useResponsiveDimensions} from '@/utils';
import {BasicObject} from '@/types';

const GAP = 8;
const PADDING = 12;

export interface DiceContainerProps {
  children?: ReactNode;
  itemNumber?: number;
  disabled?: boolean;
  onPress?: () => void;
}

const DiceContainer = ({
  itemNumber = 4,
  children,
  disabled = false,
  onPress = () => {},
}: DiceContainerProps) => {
  const {width} = useResponsiveDimensions();
  const itemWidth = (width - PADDING * 2 - GAP * (itemNumber - 1)) / itemNumber;

  return (
    <NativeTouchableOpacity
      disabled={disabled}
      onPress={onPress}
      style={[
        {width: itemWidth},
        theme.padding.tbs,
        {
          backgroundColor: 'var(--image)',
          borderWidth: 1,
          borderColor: 'rgba(255, 255, 255, 0.1)',
        },
        {boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)'} as BasicObject,
        theme.flex.center,
        theme.borderRadius.m,
      ]}>
      {children}
    </NativeTouchableOpacity>
  );
};

export default React.memo(DiceContainer);
